// Constants for the reconciliation UI. The backend is the reconciliation-tool
// FastAPI service (serving /api/v1/* — see reconClient in src/utils/axios.js),
// which owns the classification vocabulary and upload session lifecycle.

// The four terminal match outcomes emitted by the engine.
export const CLASSIFICATIONS = {
  PERFECT_MATCH: 'PERFECT_MATCH',
  FIELD_VARIANCE: 'FIELD_VARIANCE',
  ERP_ORPHAN: 'ERP_ORPHAN',
  MARMIN_ORPHAN: 'MARMIN_ORPHAN',
};

export const CLASSIFICATION_ORDER = [
  CLASSIFICATIONS.PERFECT_MATCH,
  CLASSIFICATIONS.FIELD_VARIANCE,
  CLASSIFICATIONS.ERP_ORPHAN,
  CLASSIFICATIONS.MARMIN_ORPHAN,
];

export const CLASSIFICATION_COLORS = {
  [CLASSIFICATIONS.PERFECT_MATCH]: 'success',
  [CLASSIFICATIONS.FIELD_VARIANCE]: 'warning',
  [CLASSIFICATIONS.ERP_ORPHAN]: 'error',
  [CLASSIFICATIONS.MARMIN_ORPHAN]: 'info',
};

export const SESSION_STATUSES = {
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  PARTIALLY_FAILED: 'PARTIALLY_FAILED',
  FAILED: 'FAILED',
};

export const SESSION_STATUS_COLORS = {
  [SESSION_STATUSES.PROCESSING]: 'info',
  [SESSION_STATUSES.COMPLETED]: 'success',
  [SESSION_STATUSES.PARTIALLY_FAILED]: 'warning',
  [SESSION_STATUSES.FAILED]: 'error',
};

export const COMPLIANCE_STATUS_COLORS = {
  CLEARED: 'success',
  REPORTED: 'info',
  REJECTED: 'error',
};

// The backend accepts .xlsx only, capped at 250 MB (uploads.py).
export const SOURCE_UPLOAD_FORMATS = ['.xlsx'];
export const SOURCE_UPLOAD_MAX_SIZE = 250 * 1024 * 1024;

export const RECON_LIST_POLL_INTERVAL_MS = 5000;

// Same surface tokens as the MIS dashboard so both screens read as one system.
export const RECON_UI = {
  SURFACE_WHITE: '#FFFFFF',
  SURFACE_MUTED: '#F3F4F6',
  TAB_TEXT: '#6B7280',
  TAB_TEXT_SELECTED: '#3A3F4B',
};

// Classification pill tones (design-reference palette: default/amber/red/purple).
export const PILL_TONES = {
  default: { bg: '#F3F4F6', text: '#374151', activeBg: '#111827', activeText: '#FFFFFF' },
  amber: { bg: '#FEF3C7', text: '#92400E', activeBg: '#D97706', activeText: '#FFFFFF' },
  red: { bg: '#FEE2E2', text: '#991B1B', activeBg: '#DC2626', activeText: '#FFFFFF' },
  purple: { bg: '#EDE9FE', text: '#5B21B6', activeBg: '#7C3AED', activeText: '#FFFFFF' },
};

export const CLASSIFICATION_TONES = {
  [CLASSIFICATIONS.PERFECT_MATCH]: 'default',
  [CLASSIFICATIONS.FIELD_VARIANCE]: 'amber',
  [CLASSIFICATIONS.ERP_ORPHAN]: 'red',
  [CLASSIFICATIONS.MARMIN_ORPHAN]: 'purple',
};

// Stat-tile tone text colours (ok / warn / bad).
export const TILE_TONES = {
  ok: '#059669',
  warn: '#D97706',
  bad: '#DC2626',
  default: 'inherit',
};

// Amber cell highlight for variance fields in the results table.
export const VARIANCE_HIGHLIGHT_BG = 'rgba(251, 191, 36, 0.18)';
